import Vue from 'vue'
import VueRouter from 'vue-router'
import layoutLogin from '@/layouts/LayoutLogin.vue'
import layoutDefault from '@/layouts/LayoutDefault.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/dashboard'
  },
  {
    name: 'login',
    path: '/login',
    props: true,
    meta: { layout: layoutLogin },
    component: () => import(/* webpackChunkName: "Login" */ '../views/PageLogin.vue')
  },
{
    name: 'results',
    path: '/results',
    props: true,
    meta: { layout: layoutDefault },
    component: () => import(/* webpackChunkName: "Results" */ '../views/PageResults.vue')
},

{

    path: '/areas',
    component: () => import(/* webpackChunkName: "Areas" */ '../views/PageAreas.vue'),
    meta: { layout: layoutDefault },
    children: [
      {
        name: 'area.index',
        path: '',
        redirect: 'suicide-self-harm'
      },
      {
        name: 'area',
        path: ':area',
        props: true,
        meta: { layout: layoutDefault },
        component: () => import(/* webpackChunkName: "Questions" */ '../views/PageArea.vue'),
      }
    ]
},

{
    name: 'dashboard',
    path: '/dashboard',
    props: true,
    meta: { layout: layoutDefault },
    component: () => import(/* webpackChunkName: "Dashboard" */ '../views/PageDashboard.vue')
},

{
    name: 'account',
    path: '/account',
    props: true,
    meta: { layout: layoutDefault },
    component: () => import(/* webpackChunkName: "Account" */ '../views/PageAccount.vue')
},

{
    name: 'legals',
    path: '/legals/:page',
    props: true,
    meta: { layout: layoutDefault },
    component: () => import(/* webpackChunkName: "Legals" */ '../views/PageGeneric.vue')
},

{
    name: 'addnew',
    path: '/admin/add-resources',
    props: true,
    meta: { layout: layoutDefault, requiresAdmin: true  },
    component: () => import(/* webpackChunkName: "Add New" */ '../views/PageAddNew.vue')
},

{
    name: 'addpage',
    path: '/admin/add-page',
    props: true,
    meta: { layout: layoutDefault, requiresAdmin: true },
    component: () => import(/* webpackChunkName: "Add Page" */ '../views/PageGeneric.vue')
},

{
    name: 'addarticle',
    path: '/admin/add-article',
    props: true,
    meta: { layout: layoutDefault, requiresAdmin: true },
    component: () => import(/* webpackChunkName: "Add Article" */ '../views/PageGeneric.vue')
},

{
    name: 'login-content',
    path: '/admin/edit-login',
    props: true,
    meta: { layout: layoutDefault, requiresAdmin: true },
    component: () => import(/* webpackChunkName: "Edit Login Content" */ '../views/PageEditLogin.vue')
},

  // newRoute...
  {
    name: 'article',
    path: '/article/:article',
    props: true,
    meta: { layout: layoutDefault },
    component: () => import(/* webpackChunkName: "Generic" */ '../views/PageGeneric.vue'),
  },
  {
    name: 'generic',
    path: '/:page',
    props: true,
    meta: { layout: layoutDefault },
    component: () => import(/* webpackChunkName: "Generic" */ '../views/PageGeneric.vue'),
  },
  {
    name: 'generic-child',
    path: '/:page/:child',
    props: true,
    meta: { layout: layoutDefault },
    component: () => import(/* webpackChunkName: "Generic" */ '../views/PageGeneric.vue'),
  },
  {
    name: '404',
    path: '*',
    props: true,
    meta: { layout: layoutDefault },
    component: () => import(/* webpackChunkName: "404" */ '../views/Page404.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

  router.beforeEach(async (to, from, next) => {
    const localToken = JSON.parse(localStorage.getItem('acemToken')) || JSON.parse(sessionStorage.getItem('acemToken'))
    const localUserData = localStorage.getItem('acemUser') || sessionStorage.getItem('acemUser')
    const isAuth = store.getters['Auth/isAuthenticated'] || localUserData
    const storeToken = store.state.Auth.token
    const parsedToken = localToken ? localToken.token : null
    const isAdmin = store.getters['Auth/isAdmin'] || (JSON.parse(localUserData) && JSON.parse(localUserData).role == 'admin')
    const { pages, articles, loginData } = store.state.App

    /* if resource is being edited...*/
    if (store.state.Resources.lockTabs) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
         store.dispatch('Resources/closeEditingPanel')
         next()
         return
      }
      return
  }

    /*
        If legals - we retreive the content via a page endpoint, but we use the legals route to control
        what an admin can edit.

        We check for legals first since this page can also be accessed publicly.
      */
    if (to.name == 'legals') {
      if (pages) {
        const currParent = pages.filter(({ path }) => path == `/${to.params.page}`)[0]

        if (currParent && currParent.body) return next()
      }

      if (!isAuth) {
        await store.dispatch('App/getPageData', `/${to.params.page}`)
            .then(() => next())
            .catch(err => next({ name: '404', params: { error: err } }))

            return
      }
    }

    /*
      First check if the user is authenticated
    */
    if(!isAuth) {
      // Allow user to access public pages
      const publicAccessible = ['login', 'legals']
      if (publicAccessible.includes(to.name)) next()
      // else redirect to login
      else next({ name: 'login', query: { redirectFrom: to.fullPath }})

      return
    }

    // User must be authenticated... so ensure token is set for Axios
    if (storeToken || parsedToken) {
      const token = parsedToken || storeToken
      await store.dispatch('Auth/setAxiosToken', token)
    }
    /*
      pages that require an admin level role
    */
   if (to.matched.some(record => record.meta.requiresAdmin)) {
     if (isAdmin) next()
     else next({ name: 'dashboard' })
   }


    /*
      if logged in, we dont want them navigating back to login page
    */
    if (to.name == 'login') return next({ name: 'dashboard' })

    /* get the login content if navigating to edit login */
    if (to.name == 'login-content') {
      if (!loginData) await store.dispatch('App/getLoginContent')
    }

    /*
      If initial load, we need to get the pages and articles first.
      We do this so that when VUEX calls in the page, it looks up the existing articles and appends
      the body data to the object.
    */
    if (!pages) await store.dispatch('App/getPages')
    // the default for articles is an empty array, so check that it has more than 0 items in it...
    if (!articles || articles.length < 1) await store.dispatch('App/getArticles')

    /*
      We need to ensure the nav is built before accessing generic pages,
      so we check that the app has loaded first, if not wait until it has...
    */
    if (to.name === 'generic' || to.name === 'generic-child') {
      const isStillLoadingPages = !pages || pages.length < 1

      if (isStillLoadingPages && !store.state.App.siteError) {
        setTimeout(() => { next(to.path) }, 50);
        return
      }

      // We use the .body key as all pages exist as title and path for the nav, but they haven't yet
      // loaded the content. So we check it has content or not.
      const currParent = pages.filter(({ path }) => path == `/${to.params.page}`)[0]

      if (currParent && currParent.body) return next()

      // if child, we search the currParent page for body content.
      if (to.name === 'generic-child') {
        const currParent = pages.filter(({ path }) => path == `/${to.params.page}`)[0]
        const currChild = currParent.children.filter(({ path }) => {
          return path === `/${to.params.page}/${to.params.child}`
        })[0]

        if (currChild && currChild.body) return next()
      }

      // if it doesn't, load it
      await store.dispatch('App/getPageData', to.path)
        .then(() => next())
        .catch(err => next({ name: '404', params: { error: err } }))

        return
    }

    if (to.name === 'article') {
      const isStillLoadingArticles = !articles || articles.length < 1

      if (isStillLoadingArticles && !store.state.App.siteError) {
        setTimeout(() => { next(to.path) }, 50);
        return
      }

      const article = store.state.App.articles.filter(({ path }) => path == `/${to.params.page}`)[0]

      if (article && article.body) return next()

      // if it doesn't, load it
      await store.dispatch('App/getArticleData', to.path)
        .then(() => next())
        .catch(err => next({ name: '404', params: { error: err } }))

      return
    }

    // If everything is normal, just continue on...
    next()
})

export default router
